var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@web/components/layout/Button';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { widgetMetricTableColgroupInvocationsByApp, widgetMetricTableFigureValueSpanClass, widgetMetricTablePairHeaderThClass, widgetMetricTablePeriodDiffBeforeTeamTdClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTablePeriodDiffRowCell, metricTableTeamAvgDiffRowCell } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { classNames, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { navigateToAppsUsageForDateRange } from '@web/utility/chartNavigation';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { WIDGET_TABLE_INITIAL_ROWS, WIDGET_TABLE_LOAD_MORE_ROWS } from '@workalizer/shared/config';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
export var EmailResponseSpeedAndFrequency = function (_a) {
    var _b;
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo, _c = _a.isSecondaryDiffHidden, isSecondaryDiffHidden = _c === void 0 ? false : _c;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _d = useState(WIDGET_TABLE_INITIAL_ROWS), displayedCount = _d[0], setDisplayedCount = _d[1];
    var _e = trpc.emailResponseSpeedAndFrequency.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), emailResponseData = _e.data, isLoading = _e.isLoading, refetch = _e.refetch;
    var displayedData = (emailResponseData || []).slice(0, displayedCount);
    var hasMore = ((_b = emailResponseData === null || emailResponseData === void 0 ? void 0 : emailResponseData.length) !== null && _b !== void 0 ? _b : 0) > displayedCount;
    var showTeamDiff = true;
    var metricHeaderColspan = showTeamDiff ? 3 : 2;
    var navigateToGmailAppsUsage = function () {
        navigateToAppsUsageForDateRange({
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: userId,
            orgUnitId: orgUnitId,
            tab: 'gmail'
        });
    };
    var columns = [
        {
            title: t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.name'),
            isVisible: true,
            className: 'min-w-0 !text-left'
        },
        {
            title: t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.responses'),
            isVisible: true,
            colspan: metricHeaderColspan,
            className: widgetMetricTablePairHeaderThClass
        },
        {
            title: t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.avgResponseTime'),
            isVisible: true,
            colspan: metricHeaderColspan,
            className: widgetMetricTablePairHeaderThClass
        }
    ];
    var tableData = displayedData.map(function (item) {
        var rowKey = String(item.userId);
        var responsesCells = [
            {
                id: "responses-value-".concat(rowKey),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, 'cursor-pointer'), onClick: navigateToGmailAppsUsage }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: item.responses })) }))); }
            },
            metricTablePeriodDiffRowCell("responses-period-".concat(rowKey), item.prevResponses, TablesDiffColorsConfig.GREEN, showTeamDiff ? widgetMetricTablePeriodDiffBeforeTeamTdClass : undefined, showTeamDiff ? { innerJustify: 'end' } : undefined)
        ];
        if (showTeamDiff) {
            responsesCells.push(metricTableTeamAvgDiffRowCell("responses-team-".concat(rowKey), item.teamAvgResponses, isSecondaryDiffHidden));
        }
        var avgResponseTimeCells = [
            {
                id: "avgResponseTime-value-".concat(rowKey),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, 'cursor-pointer'), onClick: navigateToGmailAppsUsage }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: item.avgResponseTime })) }))); }
            },
            metricTablePeriodDiffRowCell("avgResponseTime-period-".concat(rowKey), item.prevAvgResponseTime, TablesDiffColorsConfig.GREEN, showTeamDiff ? widgetMetricTablePeriodDiffBeforeTeamTdClass : undefined, showTeamDiff ? { innerJustify: 'end' } : undefined)
        ];
        if (showTeamDiff) {
            avgResponseTimeCells.push(metricTableTeamAvgDiffRowCell("avgResponseTime-team-".concat(rowKey), item.teamAvgResponseTime, isSecondaryDiffHidden));
        }
        return __spreadArray(__spreadArray([
            {
                id: "name-".concat(rowKey),
                className: classNames(widgetMetricTablePrimaryLabelTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: "min-w-0 max-w-full cursor-pointer font-semibold break-words", onClick: navigateToGmailAppsUsage }, { children: item.userName || item.userEmail }))); }
            }
        ], responsesCells, true), avgResponseTimeCells, true);
    });
    if (isLoading) {
        return _jsx(Loading, {});
    }
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.communicationSection.emailResponseSpeedAndFrequency'), description: t('widgetTitleDescriptions.communication.emailResponseSpeedAndFrequency'), insightType: InsightTypeEnum.emailResponseSpeedAndFrequency, insightsData: emailResponseData || [], refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.communicationSection.emailResponseSpeedAndFrequency'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, (emailResponseData !== null && emailResponseData !== void 0 ? emailResponseData : []).map(function (item) {
                                    var _a;
                                    return (_a = {},
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.name')] = item.userName || item.userEmail,
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.responses')] = item.responses,
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.avgResponseTime')] = item.avgResponseTime,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(emailResponseData !== null && emailResponseData !== void 0 ? emailResponseData : []) }) }), _jsx(Table, { columns: columns, data: isInsightsDataEmpty(emailResponseData !== null && emailResponseData !== void 0 ? emailResponseData : []) ? [] : tableData, columnColStyles: widgetMetricTableColgroupInvocationsByApp(showTeamDiff), tableClassName: "table-auto w-full", rowClassName: "[&>td]:align-top" }), hasMore && (_jsx("div", __assign({ className: "mt-4 flex justify-center" }, { children: _jsx(Button, __assign({ variant: "link", onClick: function () {
                        return setDisplayedCount(function (prev) { return prev + WIDGET_TABLE_LOAD_MORE_ROWS; });
                    } }, { children: t('loadMore') })) })))] })));
};
